interface IGTMCartEventItem {
  quantity: number;
  itemPrice: number;
  totalPrice: number;
  lineItem: any;
}

interface IGTMCartEvent extends IGTMCartEventItem {
  eventName: string;
}

export const GTMAddToCart = (eventPayload: IGTMCartEventItem) => {
  GTMEvent({ ...eventPayload, eventName: "add_to_cart" });
};

export const GTMRemoveFromCart = (eventPayload: IGTMCartEventItem) => {
  GTMEvent({ ...eventPayload, eventName: "remove_from_cart" });
};

const GTMEvent = (eventPayload: IGTMCartEvent) => {
  window.dataLayer = window.dataLayer || [];

  const { quantity, itemPrice, totalPrice, lineItem, eventName } = eventPayload;

  // Updated dataLayer as per CE-1452
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  const filteredItem = {
    item_id: lineItem?.sku ?? "",
    item_name: lineItem?.name ?? "",
    price: itemPrice ?? 0,
    quantity: quantity,
    coupon: "",
  };

  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      currency: "CAD",
      value: totalPrice,
      items: [filteredItem],
    },
  });
};
